import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { FifaSquadDataDetailVo } from './type';

/**
 * 查询Squad详情
 */
export const getSquadDetail = (params: { squadId: string; platId?: number }): AxiosPromise<FifaSquadDataDetailVo> => {
  return request({
    url: '/product/api/fifa/squad/detail',
    method: 'get',
    params
  });
};
